var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinePurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 121,
    viewBox: "0 0 79 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.2929 120.707C70.6834 121.098 71.3166 121.098 71.7071 120.707L78.0711 114.343C78.4616 113.953 78.4616 113.319 78.0711 112.929C77.6805 112.538 77.0474 112.538 76.6569 112.929L71 118.586L65.3431 112.929C64.9526 112.538 64.3195 112.538 63.9289 112.929C63.5384 113.319 63.5384 113.953 63.9289 114.343L70.2929 120.707ZM0.872478 1.99184C23.6204 4.91657 70 32.4106 70 120H72C72 31.5894 25.0463 3.08343 1.12752 0.00816423L0.872478 1.99184Z",
    fill: "#ACB4FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinePurple);
export default __webpack_public_path__ + "static/media/line-purple.8616c4f71fc07e38df4340adcf57ed4b.svg";
export { ForwardRef as ReactComponent };